export default "__VITE_ASSET__BYgOAAEW__"